import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import Commonheader from '../common/header/Commonheader';
import PubliationHeader from '../../publication/components/common/header/Commonheader'
class HeaderLoad extends Component {
    constructor(props) {
        super(props);
        this.state = {
            path:'',
        };
    }

    render() {
       
      const location = this.props.location;
      const pathname = location.pathname;
      
      var site = pathname.split("/");
      
        return (
            <Fragment>
                {/* {site.includes("publication")? <PubliationHeader />:< Commonheader/>} */}
                {site.includes("publication")? <PubliationHeader />:< PubliationHeader/>}
           </Fragment> 
        );
    }
}

const mapStateToProps = state => ({
   
    utils:state.utils,
   
    
})

export default withRouter(connect(mapStateToProps,null)(HeaderLoad));